import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextValidator } from "react-material-ui-form-validator";
import wrapStyles from "../DealerDeliveryRanges.module.scss";
import { withTranslation } from "react-i18next";
import MultiToggleWidget from "../../../../../shared/toggles/multiToggleWidget/MultiToggleWidget";
import styles from "../DealerDeliveryRanges.module.scss";

const DealerDeliveryRangesRow = (props) => {
  function getInputField() {
    return (
      <div className={wrapStyles.inputField}>
        <TextValidator
          name={`rangeValue` + props.rowNo.toString()}
          margin="normal"
          variant="outlined"
          value={props.dataRow.value === null ? "" : props.dataRow.value}
          onChange={(e) => props.onPriceChange(e, props.index)}
          validators={[
            "required",
            "minNumber:0",
            "isNumber",
            "isNumericWithTwoDecimalPlaces",
          ]}
          errorMessages={[
            props.t("nscDeliveryBands.required"),
            props.t("nscDeliveryBands.invalid"),
            props.t("nscDeliveryBands.invalid"),
            props.t("nscDeliveryBands.invalid"),
          ]}
        />
      </div>
    );
  }

  function formatRange(range) {
    return range === -1 ? "OVER" : range;
  }

  function isToggleDisabled(disabled) {
    return (
      disabled ||
      props.user.readOnly ||
      !props.user.permissions.rolePermissions.hasOwnProperty(
        "deliveryRanges:write"
      )
    );
  }
  return (
    <div className={wrapStyles.rowBorder}>
      <Grid container className="pagePaddingLeft pagePaddingRight">
        <Grid item md={4} className={wrapStyles.rowItem}>
          <span> {props.dataRow.from}</span>
          {props.dataRow.to === null ? (
            <span>&nbsp;+</span>
          ) : (
            <span>-{formatRange(props.dataRow.to)}</span>
          )}
        </Grid>
        <Grid item md={4} className={wrapStyles.rowItem}>
          {!props.editable ? (
            <div>
              <MultiToggleWidget
                settings={{
                  acceptedText: props.t("GeneralEMP.statusYes"),
                  rejectedText: props.t("GeneralEMP.statusNo"),
                  suppClass: `${
                    isToggleDisabled(props.dataRow.disabled)
                      ? ""
                      : styles.toggleWrapper
                  }`,
                }}
                isToggleDisabled={isToggleDisabled(props.dataRow.disabled)}
                toggleName={`${props.rowNo.toString()}_${props.old}`}
                currentStatus={props.dataRow.acceptedByDealer ? "yes" : "no"}
                onSelect={() =>
                  props.updateToggleStatus(props.rowNo.toString(), props.old)
                }
              />
            </div>
          ) : (
            <span>
              {props.dataRow.acceptedByDealer
                ? props.t("GeneralEMP.statusYes")
                : props.t("GeneralEMP.statusNo")}
            </span>
          )}
        </Grid>
        <Grid
          item
          md={4}
          className={`${wrapStyles.rowItem} ${wrapStyles.right}`}
        >
          {!props.freeDeliveryRow ? (
            props.editActive && !props.editable ? (
              props.dataRow.acceptedByDealer ? (
                getInputField()
              ) : (
                <span>--</span>
              )
            ) : props.dataRow.acceptedByDealer ? (
              <span>
                {props.currency}
                {props.dataRow.value}
              </span>
            ) : (
              <span>--</span>
            )
          ) : (
            <span>--</span>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default withTranslation("emp")(DealerDeliveryRangesRow);
